import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
const seamless = require('seamscroll');
import $ from 'jquery';
export default {
  name: 'standard3dList',
  data() {
    return {
      singleform: {
        limit: 100,
        page: 1
      },
      showIndex: [1],
      datas: [],
      config: {},
      stageUrl: '',
      rangeIndex: 0
    };
  },
  components: {},
  methods: {
    clickProps(e) {
      let query = this.$route.query;
      query.code = e.target.dataset.code;
      e.target.dataset.autocode ? query.autocode = e.target.dataset.autocode : '';
      this.$router.push({
        name: 'standard3dDetail',
        query: query
      });
    },
    // 获取文物列表
    getsingleformList() {
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = 113010;
      this.$api.singleformList(this.singleform).then(res => {
        this.setData(res.data);
      });
    },
    setData(data) {
      data = data.map(item => {
        let nItem = {
          columnName: this.$route.query.fid == 200375 ? this.getValInFormData(item.formData, 'columns') : this.getValInFormData(item.formData, 'column'),
          name: this.getValInFormData(item.formData, 'antiqueName'),
          img: this.getValInFormData(item.formData, 'thumbnail', 'file'),
          code: this.getValInFormData(item.formData, 'autoId'),
          showType: this.getValInFormDataList(item.formData, 'showType'),
          autoCode: this.getValInFormData(item.formData, 'autoCode')
        };
        return nItem;
      });
      this.datas = data.filter(item => {
        return item.showType.indexOf('电脑端与移动端') > -1;
      });
      let t_datas = JSON.parse(JSON.stringify(this.datas));
      this.datas.length < 20 ? this.datas = this.datas.concat(t_datas.reverse().concat(t_datas)) : '';
      this.$nextTick(() => {
        this.init();
      });
      setInterval(() => {
        this.genRandom();
      }, 2000);
    },
    getValInFormDataList(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      }).values;
      if (!target) return '';
      target = target.map(item => {
        return item.val;
      });
      return target.join(',');
    },
    genRandom(min, max) {
      setTimeout(() => {
        this.rangeIndex = this.getRangeIndex();
        $('.cont3dlist .Item3d .item ').removeClass('tobigsm');
        $('.cont3dlist .Item3d:nth-child(' + this.rangeIndex + ') .item ').addClass('tobigsm');
      }, 1000);
    },
    getRangeIndex() {
      let value = Math.random() * this.datas.length | 0;
      if (value == this.rangeIndex) return this.getRangeIndex();
      return value;
    },
    getValInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      // target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : (target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '')
      target.file = target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    // 获取页面配置
    getConfig() {
      let singleform = {
        limit: 100,
        page: 1
      };
      singleform.fid = this.$route.query.fid || '151066';
      singleform.formId = '112706';
      this.$api.singleformList(singleform).then(res => {
        let data = res.data[0];
        this.config = {
          logo: this.getConfigInFormData(data.formData, 'logo', 'img'),
          title: this.getConfigInFormData(data.formData, 'title')
        };
        document.title = this.config.title || '文物综合展示系统';
      });
      this.singleform.fid = this.$route.query.fid || '151066';
      this.singleform.formId = '112706';
      this.getsingleformList();
    },
    getConfigInFormData(data, id, type) {
      let target = data.find(d => {
        return d.alias == id;
      });
      if (!target) return '';
      target = target.values[0];
      if (!target) return '';
      // target.file = process.env.NODE_ENV == 'development' ? `https://museum.chaoxing.com/star3/origin/${target.objectId}.${target.suffix}` : (target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '')
      target.file = target.fileUrl ? target.fileUrl.replace('http:', 'https:') : '';
      return type ? target.file : target.val;
    },
    init() {
      seamless.init({
        dom: this.$refs.list,
        // 作用的dom
        step: 0.5,
        //步长,越大越快
        hoverStop: false //是否启用鼠标hover控制
      });
    },
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
      return flag;
    }
  },
  created() {
    this.stageUrl = process.env.VUE_APP_IMG_URL;
    if (this._isMobile()) {
      this.$cookie.set('_isMobile', true);
    } else {
      this.$cookie.delete('_isMobile');
    }
  },
  mounted() {
    this.getConfig();
  },
  computed: {
    isMobile() {
      return this.$cookie.get('_isMobile');
    }
  }
};